export const productOverviewActionTypes = {
    STORE_PRODUCT_LIST: "STORE_PRODUCT_LIST",
    STORE_PRODUCT_VERSION_LIST: "STORE_PRODUCT_VERSION_LIST",
    SET_SELECTED_PRODUCT_ID: "SET_SELECTED_PRODUCT_ID",
    RESET_VERSION_STATE: "RESET_VERSION_STATE",
    STORE_SINGLE_PRODUCT: "STORE_SINGLE_PRODUCT",
    STORE_SEND_VERSION_LIST: "STORE_SEND_VERSION_LIST"
}